import {
  Box,
  Button,
  Flex,
  Heading,
  Img,
  Link,
  List,
  ListIcon,
  ListItem,
  SimpleGrid,
  Text,
  VStack,
} from '@chakra-ui/react';

import React, { useState } from 'react';
import { GoDotFill } from 'react-icons/go';

const information = [
  {
    title: 'IPEM Paris 2025 – The #1 International Private Capital Event',
    link: 'https://www.ipem-market.com/paris-2025/participate/',
    cover:
      'https://static.levocdn.com/WGLBUT82/IPEMParis25kitEarlyBird1200x625-8eRjG0NfmsA3p.jpg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          IPEM Paris is the #1 international private capital event in the world,
          where the entire ecosystem—LPs, GPs, advisors, and service
          providers—meets to do business. With 6,000+ private market leaders
          from 50 countries, unmatched networking tools, and exclusive
          experiences in the heart of Paris, it's designed to accelerate deals,
          relationships, and strategic thinking.
        </Text>

        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Massive scale: 6,000+ private market leaders, 1,300+ LPs, 900+ GPs
            from 50 countries all in one place.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Complete ecosystem: LPs, GPs, advisors, and service providers
            connecting to accelerate deals and partnerships.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Unmatched networking: Advanced tools, curated meetings, and
            exclusive social experiences in Paris.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            High-level content: Strategic conferences, curated summits, and
            insights on the latest market trends and opportunities.
          </ListItem>
          <Text fontWeight="bold" fontSize="14px">
            NEW in 2025: The IPEM LP Congress (Sept. 24)
          </Text>
          <List spacing={3} mt={4}>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Private, invitation-only summit for institutional LPs, sovereign
              wealth funds, and large family offices
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Dedicated, confidential environment for investment strategy
              discussions and peer engagement
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Away from the noise, but at the centre of the action
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              Explore new opportunities with the world's leading institutional
              investors
            </ListItem>
          </List>
        </List>

        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 24th - 26th September, 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: Palais des Congrès, Paris
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Exclusive member discount until August 31st
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
  {
    title: 'SuperReturn Asia 2025 – Asia’s private capital. All in one place.',
    link: 'https://tinyurl.com/5dknsb97',
    cover:
      'https://static.levocdn.com/WGLBUT82/SuperReturnsSingapore-lDiwGcsXUwnm.jpeg',
    btnText: 'Register Now',
    desc: (
      <>
        <Text
          fontWeight={500}
          variant="featureText"
          textAlign="justify"
          my="16px"
        >
          SuperReturn Asia has cemented its position as the leading private
          markets event in Asia. The event is back and bigger than ever this
          September! Connect with 2,500+ senior private capital professionals
          from 50+ countries including 1,000+ GPs and 1,000+ LPs.
        </Text>

        <List spacing={3}>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Big names. Bigger deals. Asia’s private capital all in one place.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Insights on private markets, fundraising outlook, secondaries,
            private credit, AI, deep tech, growth capital and more.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Unmatched networking: receptions, sightseeing, women’s lunch,
            acknowledgment ceremony and more.
          </ListItem>
          <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
            <ListIcon as={GoDotFill} color="primary" />
            Speakers from AllianceBernstein, Crescent Capital Partners, Hunter
            Point Capital, Park Square Capital, Everstone and more.
          </ListItem>
          <Text fontWeight="bold" fontSize="14px">
            New features for 2025 include:
          </Text>
          <List spacing={3} mt={4}>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              The AI & Deep Tech Investing Summit
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              SuperReturn Allocate: AI-powered, quickfire 1:1 meetings programme
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              The Acknowledgments Awards Ceremony
            </ListItem>
            <ListItem fontSize="14px" fontWeight={500} color="#3d3d5f">
              <ListIcon as={GoDotFill} color="primary" />
              AGM meetings on 16 and 17 September
            </ListItem>
          </List>
        </List>
        <Box mt={5}>
          <Text fontWeight="bold" fontSize="14px">
            For more information or to register:
          </Text>
          <VStack align="start" spacing={2} mt={2}>
            <Text fontSize="14px">
              Call:{' '}
              <Link
                href="tel:+442080522013"
                color="#55B6A4"
                fontWeight="medium"
              >
                +44 (0) 20 8052 2013
              </Link>
            </Text>
            <Text fontSize="14px">
              Email:{' '}
              <Link
                href="mailto:gf-registrations@informaconnect.com"
                color="#55B6A4"
                fontWeight="medium"
              >
                gf-registrations@informaconnect.com
              </Link>
            </Text>
          </VStack>
        </Box>
        <Box mt={5}>
          <Text variant="featureText" textAlign="justify" fontWeight={600}>
            Date: 16th & 19th September 2025
          </Text>
          <Text
            mt="4px"
            fontWeight={600}
            variant="featureText"
            textAlign="justify"
          >
            Location: Marina Bay Sands Convention Centre, Singapore
          </Text>
          <Flex>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={600}
              textAlign="justify"
            >
              Save 10% with code:
            </Text>
            <Text
              mt="14px"
              variant="featureText"
              fontWeight={800}
              textAlign="justify"
            >
              FKR3539IVCA
            </Text>
          </Flex>
        </Box>
      </>
    ),
  },
];

const PartnerEvents: React.FC = () => {
  const [expandedCards, setExpandedCards] = useState<{
    [key: string]: boolean;
  }>({});

  const toggleExpanded = (title: string) => {
    setExpandedCards((prev) => {
      const isCurrentlyExpanded = prev[title];
      // If we're expanding this card, close all others
      if (!isCurrentlyExpanded) {
        return { [title]: true };
      }
      // If we're collapsing this card, just toggle it
      return {
        ...prev,
        [title]: false,
      };
    });
  };

  const truncateContent = (content: React.ReactNode, title: string) => {
    if (typeof content === 'string') {
      const words = content.split(' ');
      const isExpanded = expandedCards[title];

      if (words.length <= 60) {
        return (
          <Text variant="featureText" textAlign="justify">
            {content}
          </Text>
        );
      }

      const truncatedText = words.slice(0, 40).join(' ');

      return (
        <>
          <Text variant="featureText" textAlign="justify">
            {isExpanded ? content : truncatedText + '...'}
          </Text>
          <Text
            color="primary.500"
            cursor="pointer"
            fontWeight="700"
            fontSize="14px"
            mt="8px"
            onClick={() => toggleExpanded(title)}
            _hover={{ textDecoration: 'underline' }}
          >
            {isExpanded ? 'Read less' : 'Read more'}
          </Text>
        </>
      );
    }

    // For JSX content, we'll show it all initially and add read more/less
    const isExpanded = expandedCards[title];

    return (
      <>
        <Box maxHeight={isExpanded ? 'none' : '120px'} overflow="hidden">
          {content}
        </Box>
        <Text
          color="primary.500"
          cursor="pointer"
          fontWeight="700"
          fontSize="14px"
          mt="8px"
          onClick={() => toggleExpanded(title)}
          _hover={{ textDecoration: 'underline' }}
        >
          {isExpanded ? 'Read less' : 'Read more'}
        </Text>
      </>
    );
  };

  return (
    <Flex
      justifyContent={{ xs: 'center', lg: 'flex-start' }}
      pl={{ xs: '0%', lg: '10%', xl: '8%' }}
      bgColor="bg.lightWhite"
      py="5px"
    >
      <Box id="media-coverage" pt={{ xs: '60px' }} maxW="container.2xl" w="90%">
        <Heading
          p="0"
          fontSize={{ xs: '22px', sm: '28px', md: '30px', lg: '42px' }}
          lineHeight={{ xs: '30px', md: '40px', lg: '54.6px' }}
          fontWeight="800"
        >
          Partner Events
        </Heading>
        <SimpleGrid
          w="100%"
          mt="24px"
          gap="2rem"
          columns={{ xs: 1, md: 2, xl: 3 }}
          alignItems="start"
        >
          {information?.map((info) => (
            <Box
              boxShadow="md"
              borderRadius="xl"
              overflow="hidden"
              key={info?.title}
              bgColor="white"
              alignItems="start"
            >
              <Img height="250px" w="100%" src={info.cover} alt={info.title} />
              <Box p="1rem">
                <Heading as="h3" variant="featureTitle">
                  {info.title}
                </Heading>
                <Box
                  overflow="hidden"
                  css={{
                    '&::-webkit-scrollbar': {
                      display: 'none',
                    },
                  }}
                >
                  {truncateContent(info?.desc, info?.title)}
                </Box>
                <Link href={info.link} aria-label="learn-more" target="_blank">
                  <Button
                    colorScheme="primary"
                    aria-label="learn-more"
                    w={{ xs: '175px' }}
                    h={{ xs: '30px', md: '40px' }}
                    mt="25px"
                  >
                    {info.btnText}
                  </Button>
                </Link>
              </Box>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Flex>
  );
};

export default PartnerEvents;
